import { render, staticRenderFns } from "./studentSignupList.vue?vue&type=template&id=2c155ca0&scoped=true"
import script from "./studentSignupList.vue?vue&type=script&lang=ts"
export * from "./studentSignupList.vue?vue&type=script&lang=ts"
import style0 from "./studentSignupList.vue?vue&type=style&index=0&id=2c155ca0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c155ca0",
  null
  
)

export default component.exports